import styled from 'styled-components'
import { Spin } from 'antd'

const ContainerSegmentControl = styled.div`
  margin-top: 12px;
  padding: 0 12px 12px 12px;
`

const WrapSpin = styled(Spin)`
  margin-top: 16px;
`

const WrapTypography = styled.div`
  display: flex;
`

export { ContainerSegmentControl, WrapSpin, WrapTypography }
